export const dkgOptions = {
  epochsNum: 6,
  visibility: 'public',
  blockchain: 'base:84532',
};